<adm4-modal-dialog-title class='modal-dialog-title'
  [header]='dialogTitle'
  [showClose]='true'
  [isFullHeightContent]='true'
  (closeClicked)="closeDialog()">
  <div class="full-height" [ngClass]='backgroundClass'>
    @if (viewingFileView$ | async) {
      <adm4-deployment-file-view-container
        class='full-height'
        [fileInfo]="viewingFileView$ | async"
      [boxShadowClass]='boxShadowClass'></adm4-deployment-file-view-container>
    }
    <mat-stepper orientation="horizontal" class='default-inventory-step' [hidden]='viewingFileView$ | async' #horizontalStepper>
      <ng-template matStepperIcon='edit'>
        <mat-icon>check</mat-icon>
      </ng-template>
      <mat-step>
        <ng-template matStepLabel>Select</ng-template>
        <adm4-deployment-selection [deploymentSelection]='deploymentSelection'
          [boxShadowClass]='boxShadowClass'
          (closeDialogClicked)='closeDialog()'
          (validateDeploymentClicked)='onValidateDeployment($event)'
          (inventorySelected)='onInventorySelected($event)'
          (backgroundDeploymentStarted)="startBackgroundDeployment($event)"
        (deploymentCommentChanged)='setDeploymentComment($event)'></adm4-deployment-selection>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Validate</ng-template>
        @if (shouldRenderFixIssues(deploymentProcess$ | async, inventoryValidationStatus$ | async)) {
          <adm4-validate-deployment
            [deploymentId]='deploymentProcessId$ | async'
            [boxShadowClass]='boxShadowClass'
            (abortGeneration)='onAbortGeneration($event)'
            (previewDeploymentClicked)="onPreviewDeployment($event)"
          (repeatValidation)='onRepeatValidation($event)'></adm4-validate-deployment>
        } @else {
          @if (inventoryHasErrors(inventoryValidationStatus$ | async)) {
            <adm4-inventory-has-errors
              [inventoryValidationStatus]='inventoryValidationStatus$ | async'
              [inventoryKey]='this.selectedInventoryKey$ | async'
              (backFromInventoryHasErrors)='onChangeInventoryAfterNothingToDeploy()'
            (navigateToInventoryClick)='navigateToInventory($event)'></adm4-inventory-has-errors>
          }
          @if (isNothingToDeploy(deploymentProcess$ | async)) {
            <adm4-nothing-to-deploy
            (backFromNothingToDeploy)='onChangeInventoryAfterNothingToDeploy()'></adm4-nothing-to-deploy>
          }
        }
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Preview</ng-template>
        <div class="full-height" [ngClass]='backgroundClass'>
          @if (shouldRenderPreviewDeployment(deploymentProcess$ | async)) {
            <adm4-deployment-preview
              [deploymentId]='deploymentProcessId$ | async'
              [boxShadowClass]='boxShadowClass'
              (abortPlanning)='onAbortPlanning($event)'
              (repeatPlanning)="onRepeatPlanning($event)"
              (forceRedeployment)='onForceRedeployment($event)'
              (closeWizard)='closeDialog()'
              (deploy)='onDeploy($event)'>
            </adm4-deployment-preview>
          }
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Deploy</ng-template>
        @if (isDeployStep(deploymentProcess$ | async)) {
          <adm4-deployment
            [deploymentId]='deploymentProcessId$ | async'
            [selectedInventorySchemaType]='selectedInventorySchemaType$ | async'
            (finish)='onDoneStateReached()'
          (closeWizard)='closeDialog()'></adm4-deployment>
        }
      </mat-step>
    </mat-stepper>
  </div>
</adm4-modal-dialog-title>
